import gql from 'graphql-tag';

export default gql`
  mutation userLeaveGroup($userGroupXuid: String!, $reason: String) {
    userLeaveGroup(userGroupXuid: $userGroupXuid, reason: $reason) {
      xuid
    }
  }
`;
